// 设施状态

let getFacilityState = (state, param) => {
  let result;
  if (param === "type") {
    switch (state) {
      case 2:
        result = "success";
        break;
      case 0:
        result = "primary";
        break;
      case 1:
        result = "danger";
        break;
      default:
        result = "success";
    }
    return result;
  }
  switch (state) {
    case 2:
      result = "通过";
      break;
    case 0:
      result = "待审核";
      break;
    case 1:
      result = "驳回";
      break;
    default:
      result = "通过";
  }
  return result;
};




export default {
  getFacilityState
};

export { getFacilityState };



// WEBPACK FOOTER //
// ./src/filter/facility.js